// UnauthorizedPage.js
import React from 'react';
import { Link } from 'react-router-dom';

export default function UnauthorizedPage() {
    return (
        <div className="form-container">
            <h2>Unauthorized Access</h2>
            <p>You do not have permission to view this page.</p>
            <div style={{ textAlign: 'center', marginTop: '20px' }}>
                <Link to="/login">Back to Login</Link>
            </div>
        </div>
    );
}
